// Author YuJiaBei
// Date 2020-11-12 10:33:16

class InspectionValueType {
constructor({
        id = null,
        name = '',
        unit = '',
        description = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.unit = unit;
    this.description = description;
}
}

function newEntity() {
return new InspectionValueType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.inspection.inspectionValueType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.em.inspection.inspectionValueType.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionValueType.grid.description',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    unitFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.inspection.inspectionValueType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.em.inspection.inspectionValueType.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.inspection.inspectionValueType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'unit',
        label: 'label.em.inspection.inspectionValueType.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'description',
        label: 'label.em.inspection.inspectionValueType.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {InspectionValueType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
